/**
 * @file Table.js.
 * @author Sérgio Ferraz Souza <todentro@gmail.com>
 * @copyright Cognatis GeoAnalytics & Big Data Ltda :: 2021
 */

import Request from '../components/http/request'
import Service from './Service'

const defaultJsonHeaders = {
  headers: {
    'Content-Type': 'application/json'
  }
}

/**
 * Layer Management Service
 * @class
 */
class Table extends Service {
  constructor (options, resource) {
    super(options)
    this.resource = resource
    this.request = new Request({tag: 'das'})
    // this.request = new Request({environment: 'local', tag: 'das'})
  }

  /**
   * Get foreign keys
   *
   * @async
   * @function getForeignKey
   * @param {text} table - table
   * @return {Promise<json>} The json with the expression
   */
  async getForeignKey (table) {
    return new Promise((resolve, reject) => {
      let endPoint = `/api/0.1-a/table/${table}/foreignkey`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }

  /**
   * Get foreign keys
   *
   * @async
   * @function getForeignKey2
   * @param {string} table - table name
   * @param {string} column - column name
   * @return {Promise<json>} The json with the expression
   */
  async getForeignKey2 (table, column, schema) {
    return new Promise((resolve, reject) => {
      let endPoint = `/api/0.1-a/table/${table}/foreignkey/${column}?schema=${schema}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }

  /**
   * Get foreign keys
   *
   * @async
   * @function getForeignKey3
   * @param {string} table - table name
   * @param {Number} objectId - expression Id
   * @return {Promise<json>} The json with the expression
   */
  async getForeignKey3 (table, objectId) {
    return new Promise((resolve, reject) => {
      let endPoint = `/api/0.1-a/table/${table}/hasforeignkey/${objectId}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }

  /**
   * Get geometry column
   *
   * @async
   * @function getGeometryColumn
   * @param {string} table - The table name
   * @return {Promise<json>} The json with the expression
   */
  async getGeometryColumn (schema, table) {
    return new Promise((resolve, reject) => {
      // this.request = new Request({environment: 'local', tag: 'das'})
      let endPoint = `/api/0.1-a/table/${schema}/${table}/geometry`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }

  /**
   * Get primary key
   *
   * @async
   * @function getPrimaryKey
   * @param {string} table - table
   * @return {Promise<json>} The json with the expression
   */
  async getPrimaryKey (table) {
    return new Promise((resolve, reject) => {
      let endPoint = `/api/0.1-a/table/${table}/primarykey`

      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }


  /**
   * Get primary key
   *
   * @async
   * @function getPrimaryKey
   * @param {string} table - table
   * @return {Promise<json>} The json with the expression
   */
  async getTable (tableId) {
    return new Promise((resolve, reject) => {
      let endPoint = `/api/0.1-a/table/${tableId}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }



}

export { Table }
